"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var React = require("react");
var classNames = require("classnames");
var uuid_1 = require("uuid");
var SHARED_CLASSNAME = 'sok-tooltip-wrap';
var TIP_WIDTH = 13 * 0.8;
var TOOLTIP_HEIGHT = 3.7 * 13; // margin+padding+line height
var TOOLTIP_MARGIN = 0;
var SharedInstance = (function () {
    var instance;
    var currentItem = null;
    var createInstance = function () {
        var timeout;
        var currentTooltip = null;
        var container = document.createElement('div');
        container.classList.add('shared-tooltip-container');
        document.body.appendChild(container);
        function createClone(match) {
            var tooltip = match.children[1];
            var alignment = tooltip.dataset.alignment;
            var clone = tooltip.cloneNode(true);
            var rect = match.getBoundingClientRect();
            var contentRect = tooltip.getBoundingClientRect();
            var tip = clone.children[0];
            // Calculate tooltip position
            if (alignment.endsWith('right')) {
                clone.style.left = rect.right - contentRect.width + 'px';
                var tipPosition = rect.width / 2 - TIP_WIDTH / 2;
                if (tipPosition < contentRect.width / 2) {
                    tip.style.right = tipPosition + 'px';
                }
                else {
                    tip.style.right = contentRect.width / 2 - TIP_WIDTH / 2 + 'px';
                }
            }
            else if (alignment.endsWith('left')) {
                clone.style.left = rect.left + 'px';
                var tipPosition = rect.width / 2;
                if (tipPosition < contentRect.width / 2) {
                    tip.style.left = tipPosition + 'px';
                }
                else {
                    tip.style.left = contentRect.width / 2 + 'px';
                }
            }
            else {
                var width = document.body.clientWidth - TOOLTIP_MARGIN * 2;
                var pos = rect.left + rect.width / 2 - contentRect.width / 2;
                var tipPos = rect.left + rect.width / 2;
                // Tooltip overflow check
                if (pos <= TOOLTIP_MARGIN &&
                    pos + contentRect.width >= width - TOOLTIP_MARGIN) {
                    clone.style.left = TOOLTIP_MARGIN + 'px';
                    clone.style.right = TOOLTIP_MARGIN + 'px';
                    tip.style.left = tipPos + 'px';
                }
                else if (pos < TOOLTIP_MARGIN) {
                    // Only left side
                    clone.style.left = TOOLTIP_MARGIN + 'px';
                    tip.style.left = tipPos + 'px';
                }
                else if (pos + contentRect.width >= width - TOOLTIP_MARGIN) {
                    // Only right side
                    clone.style.right = TOOLTIP_MARGIN + 'px';
                    clone.style.left = 'auto';
                    var tipPosition = document.body.clientWidth - rect.right + rect.width / 2;
                    tip.style.right = tipPosition + 'px';
                    tip.style.left = 'auto';
                }
                else {
                    // No overflow
                    clone.style.left = pos + 'px';
                    tip.style.left = contentRect.width / 2 + 'px';
                }
            }
            if (alignment.startsWith('top')) {
                clone.style.bottom = window.innerHeight - rect.top + 'px';
            }
            else if (rect.bottom + TOOLTIP_HEIGHT > window.innerHeight) {
                clone.classList.add('topcenter');
                clone.style.bottom = window.innerHeight - rect.top + 'px';
            }
            else {
                clone.style.top = rect.bottom + 'px';
            }
            clone.classList.add('visible');
            clone.classList.add(alignment);
            container.appendChild(clone);
        }
        document.addEventListener('click', function (e) {
            if (container.childNodes.length > 0) {
                container.removeChild(container.children[0]);
            }
        });
        document.addEventListener('wheel', function (e) {
            if (container.childNodes.length > 0) {
                container.removeChild(container.children[0]);
            }
        });
        document.addEventListener('mousemove', function (e) {
            if (document.body.classList.contains('onscroll')) {
                return;
            }
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                if (!e.target) {
                    return;
                }
                var match = null;
                var currentElement = null;
                for (var i = 0; i < 5; i++) {
                    if (!currentElement) {
                        currentElement = e.target;
                    }
                    currentElement = currentElement.parentNode;
                    if (!currentElement) {
                        break;
                    }
                    if (currentElement.className === SHARED_CLASSNAME) {
                        match = currentElement;
                        break;
                    }
                }
                if (currentItem !== match) {
                    if (container.children.length > 0) {
                        container.removeChild(container.children[0]);
                        currentTooltip = null;
                    }
                    if (match) {
                        currentTooltip = match;
                        createClone(match);
                    }
                }
                currentItem = match;
            }, 120);
        });
        return Object.create({
            update: function () {
                if (container.children.length > 0 && currentTooltip) {
                    container.removeChild(container.children[0]);
                    createClone(currentTooltip);
                }
            }
        });
    };
    return {
        getInstance: function () {
            if (!instance) {
                instance = createInstance();
            }
            return instance;
        }
    };
})();
function onHoverFactory(WrappedComponent) {
    var instance = SharedInstance.getInstance();
    var identifier = (0, uuid_1.v4)();
    return function (props) {
        if (props.getInstance && props.instance !== instance) {
            props.getInstance(instance);
        }
        return (React.createElement(WrappedComponent, __assign({}, props, { className: classNames(SHARED_CLASSNAME, props.className), identifier: identifier })));
    };
}
exports.Tooltip = onHoverFactory(function (props) { return (React.createElement("div", { className: props.className, "data-identifier": props.identifier },
    props.children,
    React.createElement("div", { "data-alignment": props.tipPosition ? props.tipPosition : 'center', className: 'sok-tooltip' },
        React.createElement("div", { className: "sok-tooltip-tip" }),
        React.createElement("div", { className: "sok-tooltip-box" }, props.content)))); });
//# sourceMappingURL=index.js.map